import React, { useState } from 'react';
import ElsterSubmissionAndDataChange from '../technicalProof/submit_application/ElsterSubmissionAndDataChange';
import elsterSubmissionAndDataChangeService from '../services/claim_project_reports/elster_submission_and_data_change.service';
import FinancialYearModal from './add_financial_year/FinancialYearModal';
import { useTranslation } from 'react-i18next';
import { AddButton } from '@rd-web-markets/shared/dist/util/buttons';
const ElsterSubmission = _ref => {
  let {
    companyId,
    setLoading,
    loading,
    afterSubmitActions
  } = _ref;
  const [showFinancialYearModal, setShowFinancialYearModal] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    createSubmitStatus,
    submitStatus: lastSubmitStatus,
    interval: fetchSubmitStatusInterval
  } = elsterSubmissionAndDataChangeService.useCrud(companyId, setLoading, 'elsterApi', 'createElsterStatusApi');
  const currentYear = new Date().getFullYear().toString();
  const startDate = "01/01/".concat(currentYear);
  const endDate = "31/12/".concat(currentYear);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: '250px'
    }
  }, showFinancialYearModal && /*#__PURE__*/React.createElement(FinancialYearModal, {
    show: showFinancialYearModal,
    onHide: () => setShowFinancialYearModal(false),
    companyId: companyId,
    startDate: startDate,
    endDate: endDate,
    createElsterAction: createSubmitStatus
  }), /*#__PURE__*/React.createElement(AddButton, {
    variant: "text",
    className: "h-50",
    size: "lg",
    onClick: () => setShowFinancialYearModal(true),
    text: t('add_financial_year')
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingLeft: '30px'
    }
  }, /*#__PURE__*/React.createElement(ElsterSubmissionAndDataChange, {
    setLoading: setLoading,
    loading: loading,
    createSubmitStatus: createSubmitStatus,
    lastSubmitStatus: lastSubmitStatus,
    fetchSubmitStatusInterval: fetchSubmitStatusInterval,
    showRetryIfFailed: false,
    afterIntervalEndedCallback: afterSubmitActions
  })));
};
export default ElsterSubmission;